import React, { useContext, useEffect, useState } from 'react';
import { AgendaContext } from '../../../contexts/AgendaContext';
// Mui components
import { Box, CircularProgress, InputAdornment, OutlinedInput, Typography } from '@mui/material';
// Components
import CardEspecialidades from './CardEspecialidades';
// CustomFunctions
import { compararStringsSinDiacriticos } from '../../../utils/Functions/filterOptions';
// Icons
import iconClose from '../../../assets/icons/icon_close.svg';
import iconSearch from '../../../assets/icons/icon_search.svg';

function PantallaSeleccionEspecialidades() {
    const { solicitudProps, setSolicitudProps, consultoriosContrato } = useContext(AgendaContext);

    const especializacion = consultoriosContrato?.consultorioOsde?.find((consultorio) => consultorio.consultorioId === solicitudProps.consultorioOsde)?.especializacion;

    const [loader, setLoader] = useState(true);
    const [userText, setUserText] = useState("");
    const [especialidades, setEspecialidades] = useState(especializacion);
    const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(especialidades);


    const handleOnChangeBusqueda = (event) => {
        setUserText(event.target.value);
        setEspecialidades(especializacion.filter(especialidad => compararStringsSinDiacriticos(especialidad.descripcion, event.target.value)));
    };

    const handleCleanState = () => {
        setUserText("");
        setEspecialidades(especializacion);
    };

    useEffect(() => {
        setSolicitudProps({
            ...solicitudProps,
            especializacion: especialidadSeleccionada
        });
    }, [especialidadSeleccionada]);

    useEffect(() => {
        if (especializacion?.length > 0) {
            setLoader(false);
        }
    }, []);


    return loader ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <CircularProgress size={24} sx={{ color: 'primary' }} />
        </Box>
    ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant='h2'>Especialidades</Typography>
                <Typography variant='body1'>Las opciones corresponden a tus especialidades publicadas en cartilla y habilitadas actualmente para esta funcionalidad.</Typography>
            </Box>
            {especializacion.length >= 10 &&
                <OutlinedInput
                    value={userText}
                    placeholder='Buscá la especialidad'
                    onChange={(event) => handleOnChangeBusqueda(event)}
                    sx={{
                        display: 'flex', alignItems: 'center', padding: 1, marginBottom: '10px', width: '70%', maxWidth: '530px', maxHeight: '40px',
                        '& .MuiOutlinedInput-input': {
                            transform: 'translateY(0px)',
                            padding: '0 0 0 .5em'
                        },
                    }}
                    startAdornment={especialidades.length === 0 ?
                        (
                            <InputAdornment position="end">
                                <Box
                                    component="img"
                                    sx={{ width: "16px", height: "16px", cursor: 'pointer' }}
                                    alt="img not found"
                                    src={iconClose}
                                    onClick={() => handleCleanState()}
                                />
                            </InputAdornment>
                        )
                        :
                        (
                            <InputAdornment position="end">
                                <Box
                                    component="img"
                                    sx={{ width: "16px", height: "16px" }}
                                    alt="img not found"
                                    src={iconSearch}
                                />
                            </InputAdornment>
                        )
                    }
                />
            }
            {especialidades.length > 0 ?
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '10px' }}>
                    {especialidades && especialidades.map((especialidad) => (
                        <CardEspecialidades
                            key={especialidad.codigoOsde}
                            especialidad={especialidad}
                            especialidadSeleccionada={especialidadSeleccionada}
                            setEspecialidadSeleccionada={setEspecialidadSeleccionada}
                        />
                    ))}
                </Box>
                :
                <Box>
                    <Typography variant='h4'>Sin especialidades encontradas</Typography>
                    <Typography variant='bodyM' component='p'>No encontramos resultados para tu búsqueda. Verificá los datos ingresados e intentalo nuevamente.</Typography>

                </Box>
            }
        </Box>
    );
}

export default PantallaSeleccionEspecialidades;
